
import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import WakeUpLoader from './components/WakeUpLoader';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from 'sonner';
import AuthPage from './pages/AuthPage';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Workspace from './pages/Workspace';
import RecordPage from './pages/RecordPage';
import SettingsPage from './pages/SettingsPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from './components/ui/tooltip';
import StudioLayout from './components/StudioLayout';
import StudioDashboard from './pages/StudioDashboard';
import StudioProjectEditor from './pages/StudioProjectEditor';
import TechniquesLibrary from './pages/TechniquesLibrary';
import TechniqueWorkspace from './pages/TechniqueWorkspace';
import SDLCReference from './pages/SDLCReference';
import GeniusLabsPage from './pages/GeniusLabsPage';
import BAStudioGuide from './pages/BAStudioGuide';
import BAIntroPage from './pages/BAIntroPage';

const queryClient = new QueryClient();


function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <WakeUpLoader />;

  return user ? children : <Navigate to="/" />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <WakeUpLoader />;

  return user ? <Navigate to="/dashboard" /> : children;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <TooltipProvider>
    <AuthProvider>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <PublicRoute>
                <AuthPage />
              </PublicRoute>
            }
          />
          
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/business-analysis" element={<PrivateRoute><BAIntroPage /></PrivateRoute>} />

          <Route path="/*" element={<PrivateRoute><Layout /></PrivateRoute>}>
            
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="workspace" element={<Workspace />} />
            <Route path="record" element={<RecordPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="/studio/*" element={<PrivateRoute><StudioLayout /></PrivateRoute>}>
            <Route index element={<StudioDashboard />} />
            <Route path="techniques" element={<TechniquesLibrary />} />
            <Route path="techniques/:id" element={<TechniqueWorkspace />} />
            <Route path="sdlc" element={<SDLCReference />} />
            <Route path="genius-labs" element={<GeniusLabsPage />} />
            <Route path="guide" element={<BAStudioGuide />} />
          </Route>
          <Route path="/studio/project/:id" element={<PrivateRoute><StudioProjectEditor /></PrivateRoute>} />
        </Routes>
      </HashRouter>
      <Toaster position="top-right" />
    </AuthProvider>
    </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
